import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { I18N_OPTIONS_TOKEN } from '../injection-tokens';

@Pipe({
    name: 'phone',
    pure: false,
    standalone: true,
})
@Injectable()
export class PhonePipe implements PipeTransform {
    protected readonly i18nOptions = inject(I18N_OPTIONS_TOKEN);

    transform(rawNum: string | undefined | null): string {
        if (!rawNum || rawNum === null) {
            return '';
        }

        rawNum = this.keepOnlyNumbers(rawNum);

        if (this.i18nOptions.locale === 'en-US') {
            return this.transformUS(rawNum);
        }

        if (this.i18nOptions.locale === 'en-AU') {
            return this.transformAU(rawNum);
        }

        return rawNum;
    }

    private transformAU(rawNum: string): string {
        if (rawNum.length != 10) {
            return rawNum;
        }
        if (rawNum.startsWith('04') || rawNum.startsWith('05')) {
            return `${rawNum.slice(0, 4)} ${rawNum.slice(4, 7)} ${rawNum.slice(7)}`;
        }
        return `${rawNum.slice(0, 2)} ${rawNum.slice(2, 6)} ${rawNum.slice(6)}`;
    }

    private transformUS(rawNum: string): string {
        if (rawNum.length != 10) {
            return rawNum;
        }

        const areaCodeStr = rawNum.slice(0, 3);
        const midSectionStr = rawNum.slice(3, 6);
        const lastSectionStr = rawNum.slice(6);

        return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;
    }

    private keepOnlyNumbers(rawNum: string): string {
        return rawNum.replace(/\D/g, ''); // Remove all non-digit characters
    }
}
